import { SmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export type BatchApproveAllowanceFilterFields = {
  chainName: string;
  currency: string;
  spenderAddress: string;
  threshold: string;
  maxNumberOfAddresses: string;
  isSmartAccount: boolean;
  isPreparedAddresses: boolean;
};

export type BatchApproveAllowancePreviewParams = {
  chainId: string;
  chainType: string | number;
  assetName: string;
  spenderAddress: string;
  threshold?: string;
  limit: string;
  smartAccountType?: SmartAccountType;
  previewMode: number;
};

export const initBatchApproveAllowanceFilterFields: BatchApproveAllowanceFilterFields =
  {
    chainName: "",
    currency: "",
    spenderAddress: "",
    threshold: "",
    maxNumberOfAddresses: "1000",
    isSmartAccount: false,
    // isPreparedAddresses: true,
    isPreparedAddresses: false,
  };

export type BatchApproveAllowanceFormContextType = {
  fields: BatchApproveAllowanceFilterFields;
  setFields: Dispatch<SetStateAction<BatchApproveAllowanceFilterFields>>;
  onPreview: () => Promise<void>;
  previewParams: BatchApproveAllowancePreviewParams;
  isLoading: boolean;
  translate: (key: string, params?: Record<string, any>) => string;
};

export const BatchApproveAllowanceFormContext =
  createContext<BatchApproveAllowanceFormContextType | null>(null);

export const useBatchApproveAllowanceFormContext = () => {
  const context = useContext(BatchApproveAllowanceFormContext);

  if (!context) {
    throw new Error(
      "useBatchApproveAllowanceFormContext must be used within a BatchApproveAllowanceContextProvider",
    );
  }

  return context;
};
